/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BankAccountVerificationHistory } from './bankAccountVerificationHistory';
import { AdminDocumentEmailTimelineEntry } from './adminDocumentEmailTimelineEntry';
import { AdminDocumentTimelineEntry } from './adminDocumentTimelineEntry';
import { MerchantApplication } from './merchantApplication';


export interface AdminApplicationUnderwritingData { 
    activeAt?: string;
    application: MerchantApplication;
    bankVerificationHistory?: Array<BankAccountVerificationHistory>;
    createdAt?: string;
    documentDeliveryMethods: Array<AdminApplicationUnderwritingData.DocumentDeliveryMethodsEnum>;
    documentEmailTimeline?: Array<AdminDocumentEmailTimelineEntry>;
    documentTimeline?: Array<AdminDocumentTimelineEntry>;
    hasEsignatureAttributes?: boolean;
    inReviewAt?: string;
    providerType?: string;
    rejectedAt?: string;
    requiresBankVerification?: boolean;
    startedAt?: string;
    status: AdminApplicationUnderwritingData.StatusEnum;
    submittedAt?: string;
    submittedToProcessorAt?: string;
    tilledUnderwriting?: boolean;
    updatedAt?: string;
}
export namespace AdminApplicationUnderwritingData {
    export type DocumentDeliveryMethodsEnum = 'email' | 'api';
    export const DocumentDeliveryMethodsEnum = {
        EMAIL: 'email' as DocumentDeliveryMethodsEnum,
        API: 'api' as DocumentDeliveryMethodsEnum
    };
    export type StatusEnum = 'created' | 'started' | 'submitted' | 'test' | 'active' | 'disabled' | 'in_review' | 'rejected' | 'withdrawn';
    export const StatusEnum = {
        CREATED: 'created' as StatusEnum,
        STARTED: 'started' as StatusEnum,
        SUBMITTED: 'submitted' as StatusEnum,
        TEST: 'test' as StatusEnum,
        ACTIVE: 'active' as StatusEnum,
        DISABLED: 'disabled' as StatusEnum,
        IN_REVIEW: 'in_review' as StatusEnum,
        REJECTED: 'rejected' as StatusEnum,
        WITHDRAWN: 'withdrawn' as StatusEnum
    };
}


